import { render } from "./BaseIconSixPager.vue?vue&type=template&id=38ffd5f6"
const script = {}

import exportComponent from "/home/projects/cc-gastro/htdocs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/BaseIconSixPager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "38ffd5f6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('38ffd5f6', __exports__)) {
    console.log('reload')
    api.reload('38ffd5f6', __exports__)
  }
  
  module.hot.accept("./BaseIconSixPager.vue?vue&type=template&id=38ffd5f6", () => {
    console.log('re-render')
    api.rerender('38ffd5f6', render)
  })

}


export default __exports__